/*
 * @Author: cn1994
 * @Date: 2022-09-23 11:29:25
 * @LastEditors: cn1994
 * @LastEditTime: 2024-03-03 15:34:12
 * @Description: 组织管理路由
 */
const routes = [
  {
    path: "/organizationStructure",
    name: "organizationStructure",
    meta: {
      title: '组织架构',
      volcengine: true,
    },
    component: () => import("../pages/organizationManagement/structure/index.vue"),
  },
  {
    path: "/organizationStructureDetail",
    name: "organizationStructureDetail",
    meta: {
      title: '成员详情'
    },
    component: () => import("../pages/organizationManagement/structure/detail.vue"),
  }
];
export default routes;
